export enum ScreenType {
  'choice',
  'inline_buttons',
  'request_a_call',
}

export enum ActionType {
  'redirect',
  'moveTo',
  'startChat',
}

export enum SlidesIds {
  'startScreen',
  'justSee',
  'compliance',
  'you_were_redirected',
  'redirect_to_support',

  'requestToContact',
  'TYPContactForm',

  'howToAnswer',
}
